import { ApiError } from "../api/client";

export interface ProcessedImage {
  filename: string;
  path: string;
  size: number;
  width: number;
  height: number;
  format: string;
}

/**
 * Convierte un File a base64.
 */
function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(",")[1]; // remove data URI prefix
      resolve(base64);
    };
    reader.onerror = () => reject(new Error("Error reading file"));
    reader.readAsDataURL(file);
  });
}

/**
 * Puja una imatge al servidor (base64-encoded).
 * @param file - fitxer a pujar
 * @param type - 'recipe' | 'ingredient'
 */
export async function uploadImage(file: File, type: "recipe" | "ingredient"): Promise<ProcessedImage> {
  const base64 = await fileToBase64(file);

  const res = await fetch(`/api/images/upload`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      type,
      data: base64,
      filename: file.name,
    }),
  });

  if (res.status === 401) {
    throw new ApiError("No autenticat", 401);
  }

  if (!res.ok) {
    let msg = res.statusText;
    try {
      const data = await res.json();
      msg = data.error ?? msg;
    } catch {}
    throw new ApiError(msg, res.status);
  }

  return res.json() as Promise<ProcessedImage>;
}

/**
 * Elimina una imatge del servidor.
 */
export async function deleteImage(type: "recipe" | "ingredient", filename: string): Promise<void> {
  const res = await fetch(`/api/images/${type}/${filename}`, {
    method: "DELETE",
    credentials: "include",
  });

  if (!res.ok) {
    let msg = res.statusText;
    try {
      const data = await res.json();
      msg = data.error ?? msg;
    } catch {}
    throw new ApiError(msg, res.status);
  }
}
